export class PaidOvertimeDTO {
    constructor({
        id = 0,
        userId = 0,
        userName = '',
        organizationId = '',
        date = '',
        hours = 0,
        minutes = 0,
        comment = '',
        createdAt = '',
        createdBy = '',
        updatedAt = null,
        updatedBy = null
    } = {}) {
        this.id = id;
        this.userId = userId;
        this.userName = userName;
        this.organizationId = organizationId;
        this.date = date;
        this.hours = hours;
        this.minutes = minutes;
        this.comment = comment;
        this.createdAt = createdAt;
        this.createdBy = createdBy;
        this.updatedAt = updatedAt;
        this.updatedBy = updatedBy;
    }

    deepCopy() {
        return new PaidOvertimeDTO({ ...this });
    }
}
